import useGlobalModel from "@/model/globalModel"
import { Modal } from "antd"
import axios from "axios"
import PDFObject from 'pdfobject'

import mammoth from 'mammoth'
import { useState } from "react"
import { useEffect } from "react"


function PDFPreview() {
    const {
        officeLookInfo,
        setOfficeLookInfo,
    } = useGlobalModel()

    useEffect(() => {
        if(officeLookInfo.visible){
            // getHtml()
            const container = document.getElementById('pdfContainer');
                // 使用 PDFObject 显示 PDF
             PDFObject.embed(officeLookInfo.url , container);
        }else{
            // setHtml(null)
        }
    },[officeLookInfo.visible])

    const [html, setHtml] = useState<string | null>(null)

    const getHtml = () => {
        axios.get(officeLookInfo.url, {responseType: "arraybuffer"}).then(res=>{
            mammoth
            .convertToHtml({ arrayBuffer: res.data })
            .then(function (resultObject) {
              setHtml(resultObject.value)
            });
        })
    }

    return (
        <Modal
                title="文件预览"
                visible={officeLookInfo.visible}
                width={920}
                onCancel={() => {
                    setOfficeLookInfo({ visible: false, url: '' })
                }}
                footer={[]}
                bodyStyle={{ minHeight: '300px', maxHeight: 'calc(100vh - 84px)', padding: '10px', }}
            >
                <div id="pdfContainer" style={{ width: '880px', height:"823px" }}>
                    {officeLookInfo.url && (
                        // <iframe src={`${officeLookInfo.url}`} width="100%" height="823px"></iframe>
                        // <embed src={`${officeLookInfo.url}`} type="application/pdf" width="100%" height="600px" />
                        <object data={officeLookInfo.url} type="application/pdf" width="100%" height="100%">
                            <iframe src={officeLookInfo.url} width="100%" height="100%"></iframe>
                        </object>
                    )}
                    {/* {html &&  <div dangerouslySetInnerHTML={{__html: html}}></div>} */}
                </div>
            </Modal>
    )
}

export default PDFPreview
